import {HttpModelConverter} from "../../../core/converter/httpModel.converter";
import {AdditionalPropertyModel} from "../model/additionalProperty.model";

export class AdditionalPropertyConverter extends HttpModelConverter<AdditionalPropertyModel>{
    protected createInstance(): AdditionalPropertyModel {
        return new AdditionalPropertyModel();
    }

    protected enrichObject(result: AdditionalPropertyModel, src: AdditionalPropertyModel) {
        return result;
    }



}